export default __webpack_public_path__ + "static/media/strasbourg19.fcab3891.jpg";